/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";

export const ConfigSettingsLoading = defineComponent({
  name: "ConfigSettingsLoading",
  setup() {
    const { t } = useLocalization();

    return () => (
      <div class="flex min-h-[420px] items-center justify-center">
        <div class="text-center">
          <div class="relative inline-block">
            <div class="w-16 h-16 border-4 border-primary/20 border-t-primary rounded-full animate-spin"></div>
            <span class="material-symbols-outlined text-primary text-2xl absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
              tune
            </span>
          </div>
          <p class="mt-6 text-sm font-medium text-base-content/70">
            {t("settings.config.loading")}
          </p>
        </div>
      </div>
    );
  },
});
